function ArrowIcon({ direction }: { direction: "next" | "prev" }) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d={direction === "next" ? "M9 6l6 6-6 6" : "M15 6l-6 6 6 6"}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SampleNextArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      className={
        " absolute h-fit bg-gray-500 text-neutral-100 p-2 px-4 w-fit rounded-full inset-0 mt-auto ml-auto mr-2 -mb-16"
      }
      onClick={onClick}
    >
      <ArrowIcon direction="next" />
    </div>
  );
}

export function SamplePrevArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      className={
        " absolute z-20 bg-gray-500 text-neutral-100 p-2 px-4 w-fit h-fit rounded-full inset-0 mt-auto mr-auto ml-2 -mb-16"
      }
      onClick={onClick}
    >
      <ArrowIcon direction="prev" />
    </div>
  );
}

export function CustomPaging({
  index,
  currentIndex,
}: {
  index: number;
  currentIndex: number;
}) {
  return (
    <div
      className={`w-6 h-2 cursor-pointer relative -bottom-10 ${
        currentIndex === index ? "bg-gray-500" : "bg-gray-300"
      }`}
    ></div>
  );
}
